module.exports = __webpack_public_path__ + "static/img/quesheng2.728edf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/quesheng2.png
// module id = X59q
// module chunks = 1